// extracted by mini-css-extract-plugin
export default {"node":"TranslationAlternativeText_node__KcoY9"};